import classNames from 'classnames'
import * as React from 'react'
import {
    translate
} from 'react-i18next'
import { Interpolate } from 'react-i18next'
import { t, x } from '../../../helpers/localization'
import { Currency, Divider, Message, Tooltip, TooltipBody, TooltipHeader, ProgressBar } from '@wg/wows-react-uikit'
import styles from './LevelTooltip.scss'
import get from 'lodash/get'

type IProps = {
    name: string,
    level: number,
    title: string,
    price: number,
    bonus: string,
    balance: number,
    isAvailable: boolean,
    isReady: boolean,
    hasBuildPermission: boolean,
    isRequiredPreviousLevel: boolean,
    isOwnBase: boolean,
    meta: any,
    accumulativeResource: Number,
}

class LevelTooltip extends React.PureComponent<IProps, any> {

    getPercentProgress = () => {
        let progress = 0

        if (this.props.accumulativeResource > 0 && this.props.meta.accumulativeResourceRequired > 0) {
            progress = this.props.accumulativeResource / this.props.meta.accumulativeResourceRequired
        }

        if (this.props.accumulativeResource > this.props.meta.accumulativeResourceRequired) {
            progress = 1
        }

        return Math.min(1, progress)
    }

    render() {
        const lackOfResources = this.props.price - this.props.balance
        const isNotEnoughResources = lackOfResources > 0
        const isTreasury = this.props.name === 'treasury'
        const needAccumulativeResource = this.props.accumulativeResource < this.props.meta.accumulativeResourceRequired && isTreasury
        const needBattles = get(this.props.meta, 'levelRequirements.battleCount', 0)
        const battleType = get(this.props.meta, 'levelRequirements.type', undefined)
        const currentBattles = battleType ? this.props.battlesStats[battleType] : 0
        const battleProgress = (currentBattles / needBattles) > 1 ? 1 : currentBattles / needBattles

        return (
            <Tooltip>
                <TooltipHeader isBold={false} isHelpIcon={false}>
                    <div className={classNames(styles.title, {
                        [styles.isReady]: this.props.isReady,
                    })}>
                        <Interpolate
                            i18nKey={x('Улучшение %(level)s')}
                            level={this.props.level}
                        />
                    </div>
                    <div className={styles.subTitle}>{this.props.title}</div>
                </TooltipHeader>
                <TooltipBody>
                    {this.props.meta.buyable ? (
                        <React.Fragment>
                            {this.props.isReady
                                ? (<Message style={'inline'} type="done">{t('Построено')}</Message>)
                                : (<Message style={'inline'} type="error">{t('Не построено')}</Message>)
                            }
                        </React.Fragment>
                    ) : (
                            <React.Fragment>
                                {this.props.isReady
                                    ? (<Message style={'inline'} type="done">{t('Достигнуто')}</Message>)
                                    : (<Message style={'inline'} type="error">{t('Не достигнуто')}</Message>)
                                }
                            </React.Fragment>
                        )}

                </TooltipBody>
                {this.props.meta.function ? <Divider type="major" /> : null}
                <TooltipBody>
                    {this.props.meta.function}
                </TooltipBody>
                {(!this.props.isReady && !this.props.meta.buyable) ? (
                    <React.Fragment>
                        <Divider type="major" />
                        <TooltipBody>
                            <Message style={'inline'} type="error">{t('Появляется автоматически при достижении определённого количества боев')}</Message>
                        </TooltipBody>
                    </React.Fragment>
                ) : null}
                {(!this.props.isReady && !this.props.meta.buyable) ? (
                    <React.Fragment>
                        <Divider type="major" />
                        <TooltipBody>
                            <div className={styles.tooltipProgressRow}>
                                {t('Общее количество боев:')}
                                <Interpolate
                                    i18nKey={x('%(currentBattles)s/%(needBattles)s')}
                                    currentBattles={currentBattles === null ? 0 : currentBattles}
                                    needBattles={needBattles}
                                />
                            </div>
                            <ProgressBar
                                size={'small'}
                                completed={battleProgress}
                            />
                        </TooltipBody>
                    </React.Fragment>
                ) : null}

                {(!this.props.isReady && this.props.meta.buyable)
                    ? (
                        <React.Fragment>
                            <Divider type="major" />
                            <TooltipBody>
                                <div className={styles.price}>
                                    {t('Стоимость постройки:')}
                                    <Currency
                                        isBold
                                        type="oil"
                                        amount={this.props.price}
                                        t={t}
                                    />
                                </div>
                                {
                                    (this.props.isOwnBase && isNotEnoughResources) &&
                                    (
                                        <div style={{ color: '#ff6600' }} className={styles.price}>
                                            <Message type="danger" style="inline">{t('Не хватает:')}</Message>
                                            <Currency
                                                isBold
                                                type="oil"
                                                amount={lackOfResources}
                                                t={t}
                                            />
                                        </div>
                                    )
                                }
                            </TooltipBody>
                        </React.Fragment>
                    )
                    : null
                }
                {this.props.bonus ?
                    (
                        <React.Fragment>
                            <Divider type="major" />
                            <TooltipBody>
                                {this.props.bonus}
                            </TooltipBody>
                        </React.Fragment>
                    ) : null
                }
                {(this.props.isOwnBase && !needAccumulativeResource && this.props.meta.buyable && (!this.props.hasBuildPermission || this.props.isRequiredPreviousLevel)) &&
                    (
                        <React.Fragment>
                            {(this.props.isOwnBase && !this.props.hasBuildPermission) || (this.props.isOwnBase && this.props.isRequiredPreviousLevel) ? <Divider type="major" /> : null}
                            <TooltipBody>
                                {(this.props.isOwnBase && !this.props.hasBuildPermission) &&
                                    <Message style={'inline'} type="warning">{t('Только командный состав может улучшить строение.')}</Message>
                                }
                                {(this.props.isOwnBase && this.props.isRequiredPreviousLevel) &&
                                    <Message style={'inline'} type="warning">{t('Для приобретения улучшения необходимо построить предыдущие улучшения.')}</Message>
                                }
                            </TooltipBody>
                        </React.Fragment>
                    )
                }
                {needAccumulativeResource ? (
                    <React.Fragment>
                        <Divider type="major" />
                        <TooltipBody>
                            <Message style={'inline'} type="error">{t('Вы можете приобрести улучшение только после того как клан заработает определенное количество нефти и после постройки предыдущих улучшений')}</Message>
                        </TooltipBody>
                    </React.Fragment>
                ) : null}
                {(this.props.isOwnBase && isTreasury && this.props.meta.accumulativeResourceRequired > 0 && !this.props.isReady) ? (
                    <React.Fragment>
                        <Divider type="major" />
                        <TooltipBody>
                            <div className={styles.tooltipProgressRow}>
                                {t('Всего получено:')}
                                <Currency
                                    amount={`${Math.min(this.props.accumulativeResource, this.props.meta.accumulativeResourceRequired)}/${this.props.meta.accumulativeResourceRequired}`}
                                    isBold={true}
                                    type={'oil'}
                                    onlyIcon={false}
                                    withMargin={false}
                                    color={'#fff'}
                                />
                            </div>
                            <ProgressBar
                                size={"small"}
                                completed={this.getPercentProgress()}
                            />
                        </TooltipBody>
                    </React.Fragment>
                ) : null}
            </Tooltip>
        )
    }
}

export default translate()(LevelTooltip)